import React, { useContext, useMemo } from "react";
import clsx from "clsx";
import isEmpty from "lodash/isEmpty";
import useTheme from "@material-ui/core/styles/useTheme";
import useMediaQuery from "@material-ui/core/useMediaQuery";
import ReactAnimation from "@micado-digital/react-animation/ReactAnimation";
import ProductDetailContext from "@micado-digital/react-shop/ProductDetail/context/ProductDetailContext";
import Container from "../../../components/Container";
import Information from "../Information";

import styles from "./Animation.styles";

const Animation = ({ lang }) => {
	const { productDetailData } = useContext(ProductDetailContext);
	const { groups } = productDetailData || {};
	const theme = useTheme();
	const isMobile = useMediaQuery(theme.breakpoints.down("sm"));
	const css = styles();

	const data = useMemo(() => {
		if (isEmpty(groups)) return;

		const defaultGroup = groups?.find(group => group?.default);

		if (isEmpty(defaultGroup?.mediaList)) return;

		return {
			entries: 1,
			items: [
				{
					id: 1,
					media: defaultGroup?.mediaList?.[0]
				}
			],
			sequence: "continuousendless",
			transitionEffect: "fade"
		};
	}, [groups]);

	return (
		<div className={clsx(css.animation, "mco-shop-product-detail-animation")}>
			{!isEmpty(data) && (
				<ReactAnimation
					absoluteMediaURLs
					data={data}
					key={JSON.stringify(data)}
					mediaFormats={{ xs: "productgroup-animation" }}
					webpFallback
				/>
			)}
			{!isMobile && (
				<Container>
					<Information lang={lang} />
				</Container>
			)}
		</div>
	);
};

export default Animation;
